import { AccessControlEnum } from '../../core/models/access-control.enum';
import { Type } from '@angular/core';
import { ReportCode } from './report-code';
import { ReportKey } from './report-key';
import { FileType } from './file-type';
import { ReportParamsEnum } from './report-params.enum';

export class Report {
  public available: boolean;
  public component: Type<any>;
  public format: FileType = FileType.PDF;
  public icon: string;
  public isDriverBased: boolean = false;
  public isRegionFilterable: boolean;
  public isVehicleBased: boolean = true;
  public isZoneFilterable: boolean;
  public key: string;
  public moduleName: AccessControlEnum;
  public moduleNameCanGenerate: AccessControlEnum;
  public params: any = {};
  public paramsDefaultValue: any = {};
  public validators: any;

  constructor(
    public code: string,
    private _params?: any
  ) {
    if (this.code) {
      if (_params) {
        this.params = _params;
      }
      this.moduleName = AccessControlEnum.ReportName(this.code);
      this.moduleNameCanGenerate = AccessControlEnum.ReportNameGenerate(this.code);
      this.key = ReportKey[Object.keys(ReportCode).find(key => ReportCode[key] === code)];
      this.isRegionFilterable = true;
      this.isZoneFilterable = false;
      this.setIcon();
      this.setData();
    }
  }

  private setIcon() {
    switch (this.key) {
      case ReportKey.VehicleUsageReport:
      case ReportKey.VehicleUsageVatSettlementReport:
      case ReportKey.TripsReport:
      case ReportKey.RoadReport:
        this.icon = 'fa-car';
        break;
      case ReportKey.FuelReport:
      case ReportCode.FuelingStationReport:
        this.icon = 'fa-gas-pump';
        break;
      case ReportKey.PrivateUseReport:
        this.icon = 'fa-coffee';
        break;
      case ReportKey.WinterReport:
        this.icon = 'fa-snowplow';
        break;
      case ReportKey.ZoneVisitsReport:
        this.icon = 'fa-draw-circle';
        break;
      case ReportKey.StopsReport:
        this.icon = 'fa-circle-stop';
        break;
      case ReportKey.DailyRoadReport:
        this.icon = 'fa-memo';
        break;
      case ReportKey.Psg10Report:
        this.icon = 'fa-lock';
        break;
      case ReportKey.Psg10AReport:
        this.icon = 'fa-lock';
        break;
      case ReportKey.Psg12Report:
        this.icon = 'fa-lock';
        break;
      case ReportKey.OverspeedingReport:
        this.icon = 'fa-gauge-max';
        break;
      case ReportKey.TasksReport:
        this.icon = 'fa-list-check';
        break;
      case ReportKey.CorporateUsageSummaryReport:
        this.icon = 'fa-buildings';
        break;
      case ReportKey.UnitHistoryReport:
        this.icon = 'fa-location-dot';
        break;
      case ReportKey.MileageReport:
        this.icon = 'fa-meter';
        break;
      case ReportKey.BorderCrossingReport:
        this.icon = 'fa-globe';
        break;
    }
  }

  private setData() {
    switch (this.code) {
      case ReportCode.VehicleUsageVatSettlementReport:
        this.params.checkbox = [ReportParamsEnum.SHOULD_CONTAIN_DETAILED_ROUTE_DESCRIPTION];
        this.validators = { dateRange: true, maxUnits: 1 };
        break;
      case ReportCode.VehicleUsageReport:
        this.validators = { dateRange: true, maxUnits: 1 };
        break;
      case ReportCode.UnitHistoryReport:
        this.format = FileType.CSV;
        this.validators = { dateRange: true, maxUnits: 1 };
        break;
      case ReportCode.RoadReport:
        this.params.checkbox = [ReportParamsEnum.ONLY_DRIVING_STATE, ReportParamsEnum.GROUP_BY_DAYS, ReportParamsEnum.INCLUDE_SENSORS, ReportParamsEnum.INCLUDE_FUEL_DATA, ReportParamsEnum.INCLUDE_RPM];
        this.paramsDefaultValue = { groupByDays: true, includeSensors: true, includeFuelData: false, includeRpm: false };
        this.validators = { dateRange: true };
        break;
      case ReportCode.FleetStatusReport:
        this.validators = {};
        break;
      case ReportCode.WorkCardReport:
        this.params.checkbox = [ReportParamsEnum.INCLUDE_SENSORS];
        this.validators = { dateRange: true, maxUnits: 1 };
        break;
      case ReportCode.UnitsWorkCardSummaryReport:
        this.params.checkbox = [ReportParamsEnum.SHOULD_INCLUDE_MTH_AND_FUELLEVEL];
        this.validators = { dateRange: true };
        break;
      case ReportCode.FuelReport:
        this.validators = { dateRange: true };
        break;
      case ReportCode.PrivateUseReport:
        this.params.radio = [ReportParamsEnum.AGGREGATION_TYPE, ReportParamsEnum.BUSINESS_DRIVE_TIME_INDICATOR];
        this.validators = { dateRange: true };
        break;
      case ReportCode.IdlingReport:
        this.validators = { dateRange: true };
        break;
      case ReportCode.DataContinuityReport:
        this.validators = { dateRange: true };
        break;
      case ReportCode.ClientAccumulatedMillageReport:
        this.validators = { dateRange: true };
        break;
      case ReportCode.WinterReport:
        this.params.checkbox = [ReportParamsEnum.GROUP_BY_DAYS, ReportParamsEnum.INCLUDE_SENSORS];
        this.paramsDefaultValue = { groupByDays: true, includeSensors: true };
        this.validators = { dateRange: true };
        break;
      case ReportCode.ZoneVisitsReport:
        this.validators = { dateRange: true };
        this.isRegionFilterable = false;
        this.isZoneFilterable = true;
        break;
      case ReportCode.StopsReport:
        this.validators = { dateRange: true };
        break;
      case ReportCode.DailyRoadReport:
        this.params.checkbox = [ReportParamsEnum.INCLUDE_SENSORS];
        this.paramsDefaultValue = { includeSensors: true };
        this.validators = { dateRange: true };
        this.isZoneFilterable = true;
        break;
      case ReportCode.Psg10Report:
        this.format = FileType.XLSX;
        this.validators = { dateRange: true, maxUnits: 1 };
        break;
      case ReportCode.Psg10AReport:
        this.format = FileType.XLSX;
        this.validators = { dateRange: true, maxUnits: 1 };
        break;
      case ReportCode.Psg12Report:
        this.format = FileType.XLSX;
        this.validators = { dateRange: true, maxUnits: 1, maxDays: 1 };
        break;
      case ReportCode.OverspeedingReport:
        this.validators = { dateRange: true, maxUnits: 1, maxDays: 31 };
        break;
      case ReportCode.TasksReport:
        this.validators = { dateRange: true };
        break;
      case ReportCode.CorporateUsageSummaryReport:
        this.validators = { dateRange: true, maxUnits: 1 };
        break;
      case ReportCode.DriverWorkCardReport:
        this.isVehicleBased = false;
        this.isDriverBased = true;
        this.validators = { dateRange: true, maxDrivers: 1 };
        break;
      case ReportCode.TripsReport:
        this.params.checkbox = [ReportParamsEnum.SHOULD_CONTAIN_DETAILED_ROUTE_DESCRIPTION];
        this.validators = { dateRange: true, maxUnits: 1 };
        break;
      case ReportCode.MileageReport:
        this.format = FileType.CSV;
        this.isRegionFilterable = false;
        this.validators = { dateRange: true, maxDays: 90 };
        break;
      case ReportCode.FuelingStationReport:
        this.isVehicleBased = false;
        this.isDriverBased = false;
        this.isRegionFilterable = false;
        this.validators = { dateRange: true, maxDays: 180 };
        break;
      case ReportCode.BorderCrossingReport:
        this.validators = { dateRange: true };
        break;
    }
  }
}
